module.exports = __webpack_public_path__ + "static/media/Icon_Azul.e15faffd.svg";